export default __webpack_public_path__ + "static/twitter-811a1584db463d7394aadff4f74cebe0.png";